import React, { useEffect, useRef, useState } from 'react';
import { Mail, Phone, Linkedin, MapPin } from 'lucide-react';
import { profileData } from '../data/mock';

const Contact = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const contactInfo = [
    {
      icon: Mail,
      label: 'Email',
      value: profileData.email,
      link: `mailto:${profileData.email}`
    },
    {
      icon: Phone,
      label: 'Phone',
      value: profileData.phone,
      link: `tel:${profileData.phone}`
    },
    {
      icon: Linkedin,
      label: 'LinkedIn',
      value: 'Connect with me',
      link: profileData.linkedin
    },
    {
      icon: MapPin,
      label: 'Location',
      value: profileData.location,
      link: null
    }
  ];

  return (
    <section id="contact" ref={sectionRef} className="py-20 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-center mb-4">
            Get In <span className="text-cyan-400">Touch</span>
          </h2>
          <div className="w-20 h-1 bg-cyan-400 mx-auto mb-8"></div>
          <p className="text-center text-gray-400 text-lg mb-12 max-w-2xl mx-auto">
            I'm always open to discussing new projects, creative ideas, or opportunities to be part of your vision.
          </p>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {contactInfo.map((info, index) => {
              const IconComponent = info.icon;
              const content = (
                <div className="bg-slate-900 rounded-xl p-6 shadow-lg border border-slate-800 hover:border-cyan-400 transition-all duration-300 transform hover:-translate-y-2 h-full">
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="bg-cyan-500/10 p-4 rounded-full">
                      <IconComponent className="text-cyan-400" size={28} />
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-white mb-2">{info.label}</h3>
                      <p className="text-gray-400 text-sm break-words">{info.value}</p>
                    </div>
                  </div>
                </div>
              );

              return info.link ? (
                <a
                  key={index}
                  href={info.link}
                  target={info.label === 'LinkedIn' ? '_blank' : undefined}
                  rel={info.label === 'LinkedIn' ? 'noopener noreferrer' : undefined}
                  className="block"
                >
                  {content}
                </a>
              ) : (
                <div key={index}>{content}</div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
